// @ts-nocheck
// TODO: react-beautiful-dnd package is deprecated and we need to find an alternative package for drag and drop
import React, { type JSX } from 'react';
import { useAppDispatch, useTypedSelector } from '@fiji/common/src/app/store';
import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    Stack,
    Switch,
    Typography,
} from '@mui/material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Close from '@mui/icons-material/Close';
import DragHandle from '@mui/icons-material/DragHandle';
import { useDefaultConfig, useWidgetConfigHandlers } from '../hooks';
import { ListSkeleton } from '../Skeletons';
import { CustomTransComponent, GroupPath } from 'components';
import { ArrowDropDown, Check, Settings, Warning } from '@mui/icons-material';
import { setCommandPaletteEl } from '@fiji/common/src/features/widgetManagement/commandBarWidgetSlice';
import { createNumArray } from 'utils/helpers';
import { COMMAND_PALETTE } from './commandPalette';
import { useTranslation } from 'react-i18next';
import * as Colors from '@brightlayer-ui/colors';
import { useNewCustomTranslations } from 'hooks';

const loadNumberStyle = {
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: '#727E84',
    color: '#fff',
    width: '18px',
    height: '18px',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const RearrangeChannels = (props: any): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [isConfirm, setIsConfirm] = React.useState<boolean>(false);
    const [isConfirmChecked, setIsConfirmChecked] = React.useState<boolean>(false);
    const [counter, setCounter] = React.useState<number>(0);
    useNewCustomTranslations('WIDGETS');
    const channelPayload = useTypedSelector(
        (state) =>
            state[
                props?.details?.widgetType?.id === 'settings' || props?.details?.widgetType?.id === 'properties'
                    ? 'details'
                    : props?.details?.widgetType?.id
            ]
    );

    const commandPaletteEl = useTypedSelector((state) => state.command_palette.commandPaletteEl);

    const { isLoading: widgetLoader } = useWidgetConfigHandlers();

    const { onDragEnd, handleRemoveChannel, handleChannelSelection, isCommandPaletteChecked } = useDefaultConfig(
        props?.details?.widgetType?.id
    );

    function handleSubHeading(): string {
        switch (props?.details?.widgetType?.id) {
            case 'loads':
                return t('COMMON:SELECTED_LOADS');
            case 'details':
                return t('COMMON:SECONDARY');
            case 'load_groups':
            case 'load_group_trends':
                return t('WIDGETS:LOADS_GROUPS.SELECTED_LOAD_GROUPS');
            case 'command_bar':
                return t('COMMON:SELECTED_CONTROLS');
            default:
                return t('COMMON:SELECTED_CHANNELS');
        }
    }

    const handleCloseCommandPalette = (): void => {
        dispatch(setCommandPaletteEl(null));
        setIsConfirmChecked(false);
        setCounter(0);
    };

    const handleOpenCommandPalette = (
        event: React.MouseEvent<HTMLButtonElement>,
        deviceId: string,
        channelId: string
    ): void => {
        dispatch(setCommandPaletteEl({ el: event.currentTarget, deviceId, channelId }));
    };

    const handleSelectCommandPalette = ({ color, type, channelId, deviceId, confirmRequired }: any): void => {
        handleChannelSelection(undefined, { data: { color, type }, channelId, deviceId, confirmRequired });
    };

    const getCommandBarContent = (): any => {
        if (props?.details?.widgetType?.id === 'command_bar') {
            return <CustomTransComponent translationKey={'WIDGET_MANAGEMENT:SELECT_CONTROLS'} />;
        }
        if (
            props?.details?.widgetType?.id === 'load_groups' ||
            props?.details?.widgetType?.id === 'load_group_trends'
        ) {
            return (
                <>
                    <CustomTransComponent translationKey={'WIDGETS:LOADS_GROUPS.SELECTED_LOAD_GROUPS'} />
                    {!channelPayload?.isAutomated &&
                        props?.details?.widgetType?.id === 'load_group_trends' &&
                        ` (${channelPayload?.secondary?.length}/10)`}
                </>
            );
        }
        return <CustomTransComponent translationKey={'COMMON:SELECTED_CHANNELS'} />;
    };

    const getLoadsContent = (): any => {
        if (props?.details?.widgetType?.id === 'loads') {
            return t('COMMON:LOADS');
        } else if (
            props?.details?.widgetType?.id === 'load_groups' ||
            props?.details?.widgetType?.id === 'load_group_trends'
        ) {
            return t('WIDGETS:BALANCING.TARGET_LOAD_GROUPS');
        }
        return t('COMMON:CHANNELS');
    };

    const getCount = (): any => {
        if (
            props?.details?.widgetType?.id === 'load_groups' ||
            props?.details?.widgetType?.id === 'load_group_trends'
        ) {
            return `(${channelPayload?.maxCount ?? 6})`;
        }
        return `(${(channelPayload?.primary?.length ?? 0) + (channelPayload?.secondary?.length ?? 0)})`;
    };

    const getSecondaryActionInPrimary = (item: any): JSX.Element => (
        <IconButton
            edge="end"
            aria-label="close"
            onClick={(): void => {
                handleRemoveChannel({
                    type: 'primary',
                    channel: item,
                });
            }}
        >
            <Close />
        </IconButton>
    );

    const getSecondaryActionInSecondary = (item: any): JSX.Element => (
        <Stack alignItems={'center'} direction={'row'}>
            {item?.isConfirm && <Warning color="warning" />}
            {props?.details?.widgetType?.id === 'command_bar' && (
                <Button onClick={(e) => handleOpenCommandPalette(e, item.deviceId, item?.channelId)}>
                    <Settings
                        htmlColor={
                            item?.paletteConfig?.type === 'contained' ? item?.paletteConfig?.color : Colors.white[50]
                        }
                        sx={{
                            ...(item?.paletteConfig?.type === 'contained'
                                ? {
                                      htmlColor: Colors.white[50],
                                  }
                                : {
                                      backgroundColor: item?.paletteConfig?.color,
                                      borderRadius: '50%',
                                      position: 'relative',
                                  }),
                        }}
                    />
                    <ArrowDropDown />
                </Button>
            )}
            <IconButton
                edge="end"
                aria-label="close"
                onClick={(): void => {
                    handleRemoveChannel({
                        type: 'secondary',
                        channel: item,
                    });
                }}
            >
                <Close />
            </IconButton>
        </Stack>
    );
    const getPrimaryDraggableContainer = (): JSX.Element => (
        <List disablePadding>
            {JSON.parse(JSON.stringify(channelPayload?.primary ?? []))
                ?.sort((a: any, b: any) => a?.order - b?.order)
                ?.map(
                    (channel: any, index: number, prev: any) =>
                        (prev[index - 1]?.channelId !== channel?.channelId ||
                            prev[index - 1]?.['deviceId'] !== channel?.['deviceId']) && (
                            <Draggable
                                key={`${channel?.channelId}${channel?.deviceId}`}
                                draggableId={`${channel?.channelId}${channel?.deviceId}`}
                                index={index}
                            >
                                {(providedItem): any => (
                                    <ListItem
                                        ref={providedItem.innerRef}
                                        {...providedItem.draggableProps}
                                        className="border-bottom-1 list-item-hover"
                                        disablePadding
                                        secondaryAction={getSecondaryActionInPrimary(channel)}
                                    >
                                        <ListItemButton className="padding-8" dense>
                                            <ListItemIcon {...providedItem.dragHandleProps} role={undefined}>
                                                <DragHandle />
                                            </ListItemIcon>
                                            <ListItemText
                                                className="text-secondary"
                                                primary={
                                                    <Typography variant="body2" fontWeight={'600'}>
                                                        {channel?.displayName}
                                                    </Typography>
                                                }
                                                secondary={
                                                    channel['devicePath'] && (
                                                        <GroupPath
                                                            pathName={channel['devicePath']}
                                                            deviceName={channel['deviceName']}
                                                        />
                                                    )
                                                }
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                )}
                            </Draggable>
                        )
                )}
        </List>
    );

    const handleCheck = (commandPalette: any): any => {
        const selectedChannel = channelPayload?.secondary?.find(
            (data: any) => data?.channelId === commandPalette?.channelId
        );
        return selectedChannel?.isConfirm;
    };

    const getLoadGroupTitle = (el: any): string => {
        if (!el?.[props.titleKey ?? 'displayName']) return '';
        if (typeof el?.totalLoads === 'number' || typeof el?.totalLoads === 'string') {
            return `${el[props.titleKey ?? 'displayName']} (${el.totalLoads})`;
        }
        return el[props.titleKey ?? 'displayName'];
    };

    const handleConfirmationToggleChange = (commandPaletteElement: any): any => {
        setIsConfirmChecked(true);
        setCounter((prev) => prev + 1);
        const confirmationFlag = handleCheck(commandPaletteElement);
        if (counter === 0) {
            const confirmationFlagItem = !confirmationFlag;
            setIsConfirm(confirmationFlagItem);
            handleSelectCommandPalette({
                channelId: commandPaletteElement?.channelId,
                deviceId: commandPaletteElement?.deviceId,
                confirmRequired: confirmationFlagItem,
            });
        } else {
            const isConfirmFlag = !isConfirm;
            setIsConfirm(isConfirmFlag);
            handleSelectCommandPalette({
                channelId: commandPaletteElement?.channelId,
                deviceId: commandPaletteElement?.deviceId,
                confirmRequired: isConfirmFlag,
            });
        }
    };
    const getSecondaryDraggableContainer = (): JSX.Element => (
        <List disablePadding>
            {JSON.parse(JSON.stringify(channelPayload?.secondary ?? []))
                ?.sort((a: any, b: any) => a?.order - b?.order)
                ?.map(
                    (item: any, index: number, prev: any) =>
                        (prev[index - 1]?.[props?.keyToTraverse ?? 'channelId'] !==
                            item?.[props?.keyToTraverse ?? 'channelId'] ||
                            prev[index - 1]?.['deviceId'] !== item?.['deviceId']) && (
                            <Draggable
                                key={`${item?.[props?.keyToTraverse ?? 'channelId']}${item?.deviceId}`}
                                draggableId={`${item?.[props?.keyToTraverse ?? 'channelId']}${item?.deviceId}`}
                                index={index}
                            >
                                {(providedItem): any => (
                                    <ListItem
                                        ref={providedItem.innerRef}
                                        className="border-bottom-1 list-item-hover"
                                        disablePadding
                                        secondaryAction={getSecondaryActionInSecondary(item)}
                                    >
                                        <ListItemButton
                                            className="padding-8"
                                            {...providedItem.draggableProps}
                                            role={undefined}
                                            dense
                                        >
                                            <ListItemIcon role={undefined} {...providedItem.dragHandleProps}>
                                                <DragHandle />
                                            </ListItemIcon>
                                            {props?.keyToTraverse === 'loadId' && (
                                                <Box sx={loadNumberStyle}>{item.loadNumber}</Box>
                                            )}

                                            <ListItemText
                                                {...(props.keyToTraverse === 'loadId' && {
                                                    sx: { marginLeft: '25px' },
                                                })}
                                                primary={
                                                    <Typography variant="body2" fontWeight={'600'}>
                                                        {getLoadGroupTitle(item)}
                                                    </Typography>
                                                }
                                                secondary={
                                                    (item['devicePath'] || item['groupPath'] || item?.description) && (
                                                        <Stack spacing={0.5}>
                                                            {(item['devicePath'] || item['groupPath']) && (
                                                                <GroupPath
                                                                    pathName={item['devicePath'] ?? item['groupPath']}
                                                                    deviceName={item['deviceName']}
                                                                />
                                                            )}
                                                            {Boolean(item?.description) && (
                                                                <Typography variant="caption" color="#333D43">
                                                                    {item.description}
                                                                </Typography>
                                                            )}
                                                        </Stack>
                                                    )
                                                }
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                )}
                            </Draggable>
                        )
                )}
        </List>
    );

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Grid
                py={3}
                px={2}
                className={`bg-content-wrapper w-49 ${channelPayload?.isAutomated ? 'disabled' : ''}`}
                sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
            >
                <Stack className="border-bottom-1">
                    <Typography variant="body1" fontWeight={'600'}>
                        {props?.details?.widgetType?.id === 'loads'
                            ? t('COMMON:SELECTED_LOADS')
                            : getCommandBarContent()}
                    </Typography>
                    <Typography mt={3} variant="body1" pb={3} fontWeight={'400'}>
                        {props?.details?.widgetType?.id === 'command_bar' ? (
                            <CustomTransComponent
                                translationKey={
                                    'WIDGET_MANAGEMENT:SELECT_CONTROLS_THAT_YOU_WOULD_LIKE_TO_VIEW_IN_THE_WIDGET'
                                }
                            />
                        ) : (
                            <CustomTransComponent
                                translationKey={'WIDGETS:COMMON.REARRANGE_CHANNELS_DESCRIPTION'}
                                replace={{
                                    channelType: getLoadsContent(),
                                    count: getCount(),
                                }}
                            />
                        )}
                    </Typography>
                </Stack>
                <Stack mt={2} className="max-height-630 overflow-y-auto">
                    {widgetLoader && <ListSkeleton total={5} primaryVariant="rectangular" />}
                    {!widgetLoader && (
                        <>
                            {props?.details?.widgetType?.id === 'details' && (
                                <Stack>
                                    <Typography variant="body2" ml={2}>
                                        {t('COMMON:PRIMARY')}
                                    </Typography>
                                    <Droppable droppableId="primary">
                                        {(provided): any => (
                                            <Box
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className="bg-white"
                                                my={2}
                                            >
                                                {getPrimaryDraggableContainer()}
                                                {provided.placeholder}
                                            </Box>
                                        )}
                                    </Droppable>
                                </Stack>
                            )}
                            {props?.details?.widgetType?.id === 'details' && <Divider />}
                            {!channelPayload?.isAutomated && (
                                <Stack>
                                    <Typography ml={2} variant="overline" className="text-secondary">
                                        {handleSubHeading()}
                                    </Typography>

                                    <Droppable droppableId="secondary">
                                        {(provided): any => (
                                            <Box
                                                my={2}
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className="bg-white"
                                            >
                                                {getSecondaryDraggableContainer()}
                                                {provided.placeholder}
                                            </Box>
                                        )}
                                    </Droppable>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={commandPaletteEl?.el}
                                        open={Boolean(commandPaletteEl?.el)}
                                        onClose={handleCloseCommandPalette}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button',
                                            sx: {
                                                padding: '16px',
                                                gap: '12px',
                                                backgroundColor: Colors.white[300],
                                            },
                                        }}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px',
                                                gap: '8px',
                                                borderRadius: '4px',
                                                justifyContent: 'space-between',
                                                backgroundColor: Colors.white[50],
                                            }}
                                        >
                                            <Warning color="warning" />
                                            <Typography gap={1} variant="caption">
                                                <CustomTransComponent
                                                    translationKey={
                                                        'WIDGET_MANAGEMENT:REQUIRE_ACTION_CONFIRMATION_AFTER_PRESS'
                                                    }
                                                />
                                            </Typography>
                                            <Switch
                                                checked={isConfirmChecked ? isConfirm : handleCheck(commandPaletteEl)}
                                                onChange={() => handleConfirmationToggleChange(commandPaletteEl)}
                                            />
                                        </div>
                                        <Typography variant="subtitle2" sx={{ padding: '8px' }}>
                                            <CustomTransComponent translationKey={'WIDGET_MANAGEMENT:BUTTON_COLOR'} />
                                        </Typography>
                                        {createNumArray(COMMAND_PALETTE.length / 10).map((item, stackIndex) => (
                                            <Stack direction={'row'} sx={{ justifyContent: 'space-evenly' }} key={item}>
                                                {COMMAND_PALETTE?.slice(10 * stackIndex, 10 * (stackIndex + 1)).map(
                                                    (currentPalette) => (
                                                        <Box
                                                            key={`${currentPalette.type}-${currentPalette.color}`}
                                                            sx={{
                                                                ...(currentPalette?.type === 'contained'
                                                                    ? { backgroundColor: currentPalette?.color }
                                                                    : {
                                                                          border: `2px solid ${currentPalette?.color}`,
                                                                          position: 'relative',
                                                                      }),
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                margin: '4px',
                                                                gap: '4px',
                                                            }}
                                                            onClick={() => {
                                                                const confirmationFlag = handleCheck(commandPaletteEl);
                                                                handleSelectCommandPalette({
                                                                    ...currentPalette,
                                                                    channelId: commandPaletteEl?.channelId,
                                                                    deviceId: commandPaletteEl?.deviceId,
                                                                    confirmRequired: isConfirmChecked
                                                                        ? isConfirm
                                                                        : confirmationFlag,
                                                                });
                                                            }}
                                                        >
                                                            {isCommandPaletteChecked(
                                                                channelPayload,
                                                                currentPalette.type,
                                                                currentPalette.color
                                                            ) && (
                                                                <Check
                                                                    sx={
                                                                        currentPalette?.type === 'contained'
                                                                            ? { color: '#fff' }
                                                                            : {
                                                                                  color: currentPalette?.color,
                                                                                  position: 'absolute',
                                                                                  top: '-1px',
                                                                                  left: '-2px',
                                                                              }
                                                                    }
                                                                />
                                                            )}
                                                        </Box>
                                                    )
                                                )}
                                            </Stack>
                                        ))}
                                    </Menu>
                                </Stack>
                            )}
                        </>
                    )}
                </Stack>
            </Grid>
        </DragDropContext>
    );
};
